export default "__VITE_ASSET__INHM6xX1__"